import { SelectCssClass, } from '../../../../components/src/components/select/select.types';
import { GlobalCssClass } from '../../../../components/src/utils/interfaces';
export const getCssClasses = ({ width, hiddenLabel, required, className, error, }) => {
    const classArr = [
        SelectCssClass.Base,
        GlobalCssClass.FormElement,
    ];
    if (width) {
        classArr.push(SelectCssClass[`Width${width}`], GlobalCssClass.IgnoreStack);
    }
    if (error)
        classArr.push(GlobalCssClass.FormElementInvalid);
    if (hiddenLabel)
        classArr.push(SelectCssClass.HiddenLabel);
    if (required)
        classArr.push(SelectCssClass.Required);
    if (className)
        classArr.push(className);
    return classArr.join(' ');
};
//# sourceMappingURL=IressSelect.helpers.js.map